import { computed } from '@vue/composition-api/dist/vue-composition-api'

import NAVIGATION_TYPES from '../constants'

export function useNavigationTypeFilter(props) {
  if (!props.level1Links && !props.secondaryLinks) {
    console.warn('No level 1 or secondary links in navigation')
    return
  }
  const generalLinks = computed(() => {
    return (
      props.level1Links?.filter(
        item =>
          item.navigationType === NAVIGATION_TYPES.GENERAL ||
          (!item.navigationType && item.title),
      ) || []
    )
  })
  const specialLinks = computed(() => {
    return (
      props.level1Links?.filter(
        item => item.navigationType === NAVIGATION_TYPES.SPECIAL,
      ) || []
    )
  })
  const mainLinks = computed(() => {
    return (
      props.level1Links?.filter(
        item => item.navigationType === NAVIGATION_TYPES.MAIN,
      ) || []
    )
  })

  return {
    generalLinks,
    specialLinks,
    mainLinks,
  }
}
